import {
  ActivityBuilderDrawerWrapper,
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
} from 'approot/activity-builder/activity-builder-drawer';
import {
  SettingsGroup,
  SettingsLabel,
  SettingSmallText,
} from 'approot/activity-builder/settings/settings.style';
import ActivityPresentLanguage from '../activity-present-language';
import {
  InquisitiveActivitiesContentType,
  InquisitiveLanguageCodes,
} from 'global/graphql/scalars.type';
import Feedback from 'approot/shared/feedback/feedback';
import { Box } from 'approot/shared/design-system/box/box.style';
import Switch from 'approot/shared/switch/switch';
import { grey7 } from 'approot/shared/styles/colours.style';
import { useClassSettings } from 'approot/classes/class-settings.hooks';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';
import Bouncer from 'approot/shared/bouncer/bouncer';
import { FEEDBACK_MULTI_LANGUAGE } from 'global/constants';

type Props = {
  version: string;
  contentType: InquisitiveActivitiesContentType;
  lang: InquisitiveLanguageCodes;
  availableTranslations: InquisitiveLanguageCodes[];
  onClose: () => void;
};

const PresentMenuTranslate = ({
  version,
  contentType,
  lang,
  availableTranslations,
  onClose,
}: Props) => {
  const { userClassId } = useGetInteractiveLessonParams();

  const {
    backgroundVisibility,
    animationAutoPlay,
    translationEnabled,
    translationEnabledStudent,
    loading,
    handleUpdate,
  } = useClassSettings(userClassId);

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader title="Translate" onClose={onClose} />
      <ActivityBuilderDrawerContent>
        <SettingsGroup>
          <SettingsLabel>Language</SettingsLabel>
          {version && (
            <ActivityPresentLanguage
              language={lang}
              version={version}
              contentType={contentType}
              availableTranslations={availableTranslations}
            />
          )}
        </SettingsGroup>

        {loading ? (
          <Bouncer />
        ) : (
          <SettingsGroup>
            <SettingsLabel>Enable Translation for My Students</SettingsLabel>
            <Box $marginBottom={4}>
              <Switch
                ariaLabel={`Click to ${
                  translationEnabledStudent ? 'hide' : 'show'
                } backgrounds`}
                state={translationEnabledStudent}
                onClick={() =>
                  handleUpdate({
                    classId: userClassId,
                    backgroundVisibility,
                    animationAutoPlay,
                    translationEnabled,
                    translationEnabledStudent: !translationEnabledStudent,
                  })
                }
              />
            </Box>
            <SettingSmallText colour={grey7} marginBottom={0}>
              Allow students to translate lessons and assessments into multiple
              languages.
            </SettingSmallText>
          </SettingsGroup>
        )}
        <SettingsGroup>
          <Feedback
            feature={FEEDBACK_MULTI_LANGUAGE}
            buttonText="Give Translation Feedback"
          />
        </SettingsGroup>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default PresentMenuTranslate;
